import { ContactModel, ContactDecorator } from "@/models/ContactModel";
import { AddressModel, AddressDecorator } from "@/models/AddressModel";

export const CustomerModel = {
  name: "",
  maximum_credit_amount: 0,
  payment_team: 0,
  customer_type_id: 1,
  customer_group_id: 1,
  is_allow_exceed: false,
  remarks: "-",
  addresses: [],
  phone: "",
};

export class CustomerDecorator {
  constructor(customer) {
    this.customer = customer;
    if (customer.contacts.length != 0) {
      this.customer.phone = customer.contacts[0].phone;
    }
  }

  formatAddress(addresses) {
    return addresses.map((item) => new AddressDecorator(item).toRequest());
  }

  formatContacts(addresses) {
    return addresses.map((item) => new ContactDecorator(item).toRequest());
  }

  toRequest() {
    return {
      name: this.customer.name,
      maximum_credit_amount: this.customer.maximum_credit_amount,
      payment_team: this.customer.payment_team,
      customer_type_id: this.customer.customer_type_id,
      customer_group_id: this.customer.customer_group_id,
      is_allow_exceed: this.customer.is_allow_exceed,
      remarks: this.customer.remarks,
      addresses: this.formatAddress(this.customer.addresses),
      contacts: [{ phone: this.customer.phone }],
    };
  }

  toData() {
    return {
      name: this.customer.name,
      maximum_credit_amount: this.customer.maximum_credit_amount,
      payment_team: this.customer.payment_team,
      customer_type_id: this.customer.customer_type_id,
      customer_group_id: this.customer.customer_group_id,
      is_allow_exceed: this.customer.is_allow_exceed,
      remarks: this.customer.remarks,
      addresses: this.formatAddress(this.customer.addresses),
      contacts: [{ phone: this.customer.phone }],
      phone: this.customer.phone,
    };
  }
}
